export default __webpack_public_path__ + "static/media/IMG-20240822-WA0019.8ec63775.jpg";